// extracted by mini-css-extract-plugin
export default {"box":"short-iqt-banner_box__ah5uN","label":"short-iqt-banner_label__+qlp8"};